import {
  ChangeEvent,
  ContentType,
  DayOfWeek,
  jsonCopy,
  OpeningHoursData,
} from '@bm-js/atlascloud-shared'
import MarginOptions from './MarginOptions'
import { _stringEnumValues } from '@naturalcycles/js-lib'
import Input from './Input'

function timeStringToNumber(time: string) {
  const [hours, minutes] = time.split(':').map(Number)
  const minutesAsFraction = minutes / 60
  return hours + minutesAsFraction
}

function numberToTimeString(number: number) {
  const hours = Math.floor(number)
  const minutes = Math.round((number - hours) * 60)
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
}

type Props = {
  content: ContentType<OpeningHoursData>
  setData: (
    e: ChangeEvent<OpeningHoursData['defaultOpeningHours'] | string>
  ) => void
}

const DEFAULT_OPENING_HOURS = {
  openHour: 8,
  closeHour: 17,
}

// TODO: translations
const OpeningHoursEditor = ({ content, setData }: Props) => {
  const handleOpenHourChange = (
    e: ChangeEvent,
    day: DayOfWeek,
    property: 'openHour' | 'closeHour'
  ) => {
    const updated = jsonCopy(content.data)
    let times = updated.defaultOpeningHours[day]
    if (!times) times = DEFAULT_OPENING_HOURS
    times[property] = timeStringToNumber(e.target.value)
    updated.defaultOpeningHours[day] = times
    setData({
      target: {
        name: 'defaultOpeningHours',
        value: updated.defaultOpeningHours,
      },
    })
  }

  const handleClosedOrOpenChange = (e: ChangeEvent, day: DayOfWeek) => {
    const updated = jsonCopy(content.data)
    updated.defaultOpeningHours[day] = e.target.value
      ? DEFAULT_OPENING_HOURS
      : null
    setData({
      target: {
        name: 'defaultOpeningHours',
        value: updated.defaultOpeningHours,
      },
    })
  }

  return (
    <>
      {_stringEnumValues(DayOfWeek).map((day) => (
        <div
          key={`opening-hours-${day}`}
          className='border-b border-gray-200 mb-4'
        >
          <p className='font-semibold'>{day}</p>
          <Input
            light
            label={content.data.defaultOpeningHours[day] ? 'Öppet' : 'Stängt'}
            type='checkbox'
            id={`opening-hours-${day}-closed`}
            value={!!content.data.defaultOpeningHours[day]}
            onChange={(e) => handleClosedOrOpenChange(e, day)}
          />
          {!!content.data.defaultOpeningHours[day] && (
            <>
              <Input
                light
                label='Öppnar'
                placeholder='Öppnar'
                type='time'
                value={numberToTimeString(
                  content.data.defaultOpeningHours[day]?.openHour || 0
                )}
                onChange={(e) => handleOpenHourChange(e, day, 'openHour')}
              />
              <Input
                light
                label='Stänger'
                placeholder='Stänger'
                type='time'
                value={numberToTimeString(
                  content.data.defaultOpeningHours[day]?.closeHour || 0
                )}
                onChange={(e) => handleOpenHourChange(e, day, 'closeHour')}
              />
            </>
          )}
        </div>
      ))}
      <MarginOptions topLine content={content} setData={setData} />
    </>
  )
}

export default OpeningHoursEditor
